import React from 'react'
import './collection-item.styles.scss'
import { connect } from "react-redux";
import { addItem } from "../../redux/cart/cart.actions";
import CustomButton from '../custom-button/custom-button.component'
const CollectionItem = ({item,addItem,title}) => {
    item = {...item,title:title}
    console.log(item);
    const {name,price,imageUrl,quantity,unit} = item
    return(
        <div className="collection-item">
            <div 
            className="image"
            style={{
                backgroundImage:`url(${imageUrl})`
            }}
            />
            <div className="collection-footer">
                <span className="name">{name}</span>
                <div className="item2">
                    <span className="price">{quantity} {unit}</span>
                    <span className="price">${price}</span>
                </div>
                
            </div>
            <CustomButton onClick={() => addItem(item)} inverted>
            ADD TO CART</CustomButton>
        </div>
    );
}

const mapDispatchToProps = dispatch => ({
    addItem: item => dispatch(addItem(item))
});
export default connect(null,mapDispatchToProps)(CollectionItem);